var _module = require('../components/module.js');

/*
addCommas
Adds commas every 3 places starting from the right.
*/
_module.filter('addCommas', function () {
    return function addCommas(str, includeDecimal) {
        var value = String(str);
        var decimalVal = '';

        if(~value.split('').indexOf('.')) {
            decimalVal = value.substr(value.lastIndexOf('.'));
            value = value.substr(0, value.lastIndexOf('.'));
        }

        value = value.replace(/[^0-9]+/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');

        if(includeDecimal) value += decimalVal;

        return value === '' ? str : value;
    };
});
